import React, { useRef, useState } from "react";
import Icon from "../Icon";
import { toast } from "react-toastify";
import { cropFileName, getBase64 } from "../../helpers/conversions";

const IMAGE_TYPES = ['image/svg+xml', 'image/png', 'image/gif', 'image/jpeg'];

/**
 * `accept` e `changeFile` abrem o componente para arquivo que não é imagem
 * (ex.: o .pfx do certificado): com `changeFile` o File cru é devolvido para
 * quem chamou, sem virar base64 — quem manda por multipart precisa do arquivo.
 *
 * Com `accept`, a validação passa a ser pela EXTENSÃO: o .pfx chega com mime
 * vazio ou variando por navegador, e a lista de mimes o recusaria.
 */
export const InputFile = ({label, base64, name,  changeBase64, changeName, changeFile, accept, description}) => {
    const [loading, setLoading] = useState(false);

    const ref = useRef();

    const isAllowed = file => {
        if (!accept) return IMAGE_TYPES.includes(file.type);

        return accept
            .split(',')
            .map(extension => extension.trim().toLowerCase())
            .some(extension => file.name.toLowerCase().endsWith(extension));
    };

    const upload = e => {
        let file = ref.current.files[0];

        if (!file) return;

        if (!isAllowed(file)) {
            toast.error('O formato do arquivo é inválido')
            return;
        }

        changeName(file.name);

        // Zera o input depois de ler o arquivo: sem isso, escolher DE NOVO o
        // mesmo arquivo (reenviar um certificado recusado, por exemplo) não
        // dispara onChange e o clique parece não ter acontecido.
        ref.current.value = '';

        if (typeof changeFile === 'function') {
            changeFile(file);
            return;
        }

        setLoading(true);
        getBase64(file, res => {
            changeBase64(res);
            setLoading(false);
        });
    }

    return (
        <div className={`input-group input-file-group${label ? ' has-label' : ''}`}>
            {label &&
                <label>{label}</label>
            }
            <div className="input-file-content">
                <input ref={ref} type={`file`} onChange={upload} accept={accept ?? ".jpeg, .jpg, .png, .gif, .svg"} />
                {name === '' && !loading &&
                    <button className="choose" onClick={() => ref.current.click()}><Icon name="upload-small" size={16} /> Escolher</button>
                }
                {loading &&
                    <button className="loading"><Icon name="loading" size={16} className="spin" /> Carregando...</button>
                }
                {name !== '' && !loading &&
                    <button className="complete" onClick={() => ref.current.click()}>
                        {cropFileName(name)}
                    </button>
                }
            </div>
                {description &&
                    <span className="desc">{description}</span>
                }
        </div>
    );
}

export default InputFile;
